define("settings/controllers/groups/group/social_profiles", ["exports", "@ember/controller", "@ember/object", "@ember/service", "@glimmer/tracking", "ember-concurrency"], function (_exports, _controller, _object, _service, _tracking, _emberConcurrency) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22;

  0; //eaimeta@70e063a35619d71f0,"@ember/controller",0,"@ember/object",0,"@ember/service",0,"@glimmer/tracking",0,"ember-concurrency"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let SocialProfilesController = (_dec = (0, _service.inject)('social/instagram-business'), _dec2 = (0, _emberConcurrency.task)(function* (element) {
    element.classList.add('u--glow');
    yield (0, _emberConcurrency.timeout)(3000);
    element.classList.remove('u--glow');
  }), _dec3 = (0, _emberConcurrency.task)(function* (socialProfile) {
    yield socialProfile.get('refreshAndReload').perform();

    if (socialProfile.isProfessional) {
      this.setProperties({
        socialProfile,
        showCredentialsWizard: true
      });
      this.segment.track('triggered-creds-wiz', {
        social_profile: socialProfile,
        page: this.credentials.source
      });
    }
  }), (_class = class SocialProfilesController extends _controller.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "auth", _descriptor2, this);

      _initializerDefineProperty(this, "credentials", _descriptor3, this);

      _initializerDefineProperty(this, "credentialStatus", _descriptor4, this);

      _initializerDefineProperty(this, "dialogManager", _descriptor5, this);

      _initializerDefineProperty(this, "errors", _descriptor6, this);

      _initializerDefineProperty(this, "instagramBusiness", _descriptor7, this);

      _initializerDefineProperty(this, "intl", _descriptor8, this);

      _initializerDefineProperty(this, "router", _descriptor9, this);

      _initializerDefineProperty(this, "segment", _descriptor10, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor11, this);

      _initializerDefineProperty(this, "queryParams", _descriptor12, this);

      _initializerDefineProperty(this, "showProfileCategorizationModal", _descriptor13, this);

      _initializerDefineProperty(this, "showProfileAddedModal", _descriptor14, this);

      _initializerDefineProperty(this, "showCredentialsError", _descriptor15, this);

      _initializerDefineProperty(this, "showCredentialsWizard", _descriptor16, this);

      _initializerDefineProperty(this, "showContactUsModal", _descriptor17, this);

      _initializerDefineProperty(this, "showTiktokProfileMismatched", _descriptor18, this);

      _initializerDefineProperty(this, "showCreatorProfile", _descriptor19, this);

      _initializerDefineProperty(this, "source", _descriptor20, this);

      _initializerDefineProperty(this, "hightlightComment", _descriptor21, this);

      _initializerDefineProperty(this, "openCredentialsWizard", _descriptor22, this);
    }

    get socialProfiles() {
      // Note: Parent route may delete the group
      if (this.group.isDestroying || this.group.isDestroyed) {
        return [];
      }

      return this.group.socialProfiles;
    }

    get isAccountOwner() {
      return this.auth.currentUserModel.isAccountOwner;
    }

    get numUsedSocialSets() {
      return this.auth.socialSets.filter(socialSet => socialSet.get('socialProfiles').length > 0).length;
    }

    get socialSetsRemaining() {
      const remaining = (this.totalSocialSets || 1) - this.numUsedSocialSets;
      return Math.max(remaining, 0);
    }

    get totalSocialSets() {
      return this.auth.currentAccount.totalSocialSets || 1;
    }

    get groupSlug() {
      return this.group.slug;
    }

    get brokenProfiles() {
      return this.credentialStatus.brokenProfiles;
    }

    get showAdvancedCredentialStatusModal() {
      return this.credentialStatus.displayModal;
    }

    get anySocialProfileErrors() {
      return this.socialProfiles.any(item => item.hasError);
    }

    get linkedinCredentialRefreshError() {
      const errorProfile = this.socialProfiles.find(item => item.isLinkedin && item.credentialRefreshError);
      return errorProfile?.credentialRefreshError;
    }

    get socialProfileErrorText() {
      return this.anySocialProfileErrors ? this.intl.t('account.social_accounts.errors.general') : null;
    }

    get instagramProfiles() {
      return this.socialProfiles.filter(profile => profile.isInstagram === true);
    }
    /**
     * Mobile subscribers in an empty group with no remaining social sets are
     * blocked from the add profile modal to avoid displaying an empty modal.
     */


    get isMobileSubscriptionBlockedFromAddProfile() {
      return this.socialProfiles.length === 0 && !this.socialSetsRemaining && this.isMobileSubscription;
    }

    get numUsedSocialSets() {
      return this.auth.socialSets.filter(socialSet => socialSet.get('socialProfiles').length > 0).length;
    }

    get tiktokProfile() {
      return this.socialProfiles.find(profile => profile.id === this.showTiktokProfileMismatched);
    }

    get isEligibleForTrial() {
      return this.group.get('account.canTrialPlan');
    }

    get isMobileSubscription() {
      return this.subscriptions.isMobileSubscription;
    }

    get socialSetsRemaining() {
      const remaining = (this.totalSocialSets || 1) - this.numUsedSocialSets;
      return Math.max(remaining, 0);
    }

    get totalSocialSets() {
      return this.auth.currentAccount.totalSocialSets || 1;
    }

    get canAccessOCE() {
      return this.auth.currentAccount.rolloutOcePhase1;
    }

    deleteCreatorSocialSet(socialProfile, group) {
      this.dialogManager.confirmation(this.intl.t('account.controllers.groups.confirm_social_set_deletion.title'), {
        description: this.intl.t('account.controllers.groups.confirm_social_set_deletion.description'),
        confirmButton: this.intl.t('shared_words.delete')
      }).then(confirmDelete => {
        if (confirmDelete) {
          this.deleteSocialProfile.perform(socialProfile, group);
        }
      });
    }

    *deleteSocialProfile(socialProfile, group) {
      yield fetch(`/api/v2/social_profiles/${socialProfile.id}.json`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      group.get('socialIdentities').removeObject(socialProfile);
      this.alerts.success(this.intl.t('account.controllers.groups.social_set_deleted'));
    }

    showErrors() {
      if (this.showCredentialsError && this.linkedinCredentialRefreshError) {
        this.alerts.alert(this.linkedinCredentialRefreshError);
        this.showCredentialsError = false;
      }
    }

    scrollTo(element) {
      this.scrollToTag(`#social-identity-${element}`);
    }

    goToCategorization() {
      this.set('showProfileCategorizationModal', true);
      this.set('showProfileAddedModal', false);
    }

    goToAnalytics(socialProfile) {
      this.set('showProfileAddedModal', false);
      this.router.transitionTo('cluster.analytics.profile.instagram.overview', this.groupSlug, socialProfile.urlName);
    }

    goToCalendar() {
      this.set('showProfileAddedModal', false);
      this.router.transitionTo('cluster.schedule.calendar', this.groupSlug);
    }

    openCredentialsWizard(socialProfile) {
      this.openCredentialsWizard.perform(socialProfile);
    }

    closeAdvancedCredentials() {
      this.set('displayAdvanced', false);
      this.set('credentialStatus.successfulRefresh', false);

      if (this.credentialStatus.hasMissingFeatures) {
        this.brokenProfiles.forEach(profile => {
          this.alerts.alert(this.intl.t('alerts.errors.auto_publish.expired_token.message', {
            account_name: profile.nickname
          }), {
            title: this.intl.t('shared_phrases.refresh_your_connection'),
            action: () => this.credentialStatus.connectBusinessAccount.perform(profile, 'settings'),
            actionText: this.intl.t('shared_words.refresh'),
            preventDuplicates: true
          });
        });
      }
    }

    closeTikTokProfileMismatch() {
      this.set('showTiktokProfileMismatch', false);
      this.router.transitionTo('account.groups.group.social_profiles.edit', this.auth.currentGroup.id, this.tiktokProfile.id, {
        queryParams: {
          tiktok_profile_mismatched: undefined
        }
      });
    }

    cancelTikTokProfileMismatch() {
      this.router.transitionTo({
        queryParams: {
          tiktok_profile_mismatched: undefined
        }
      });
    }

    async connectProfile(socialProfile) {
      if (socialProfile.hasBusinessAccount && socialProfile.needsBusinessTokenRefresh) {
        this.connectBusinessAccount(socialProfile);
      } else {
        this.connectPersonalAccount(socialProfile);
      }
    }

    scrollToTag(tag) {
      const element = document.querySelector(tag);
      element.scrollIntoView({
        behavior: 'smooth'
      });
      this.hightlightComment.perform(element);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "credentials", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "credentialStatus", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "instagramBusiness", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "queryParams", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return ['showCredentialsWizard', 'source', {
        showCredentialsError: 'show_credentials_error'
      }, {
        showTiktokProfileMismatched: 'tiktok_profile_mismatched'
      }];
    }
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "showProfileCategorizationModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "showProfileAddedModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "showCredentialsError", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "showCredentialsWizard", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "showContactUsModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "showTiktokProfileMismatched", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "showCreatorProfile", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "source", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 'account-settings';
    }
  }), _applyDecoratedDescriptor(_class.prototype, "deleteCreatorSocialSet", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "deleteCreatorSocialSet"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deleteSocialProfile", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "deleteSocialProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showErrors", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "showErrors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "scrollTo", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "scrollTo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToCategorization", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "goToCategorization"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToAnalytics", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "goToAnalytics"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToCalendar", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "goToCalendar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openCredentialsWizard", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openCredentialsWizard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeAdvancedCredentials", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeAdvancedCredentials"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeTikTokProfileMismatch", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeTikTokProfileMismatch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cancelTikTokProfileMismatch", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "cancelTikTokProfileMismatch"), _class.prototype), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "hightlightComment", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "openCredentialsWizard", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class));
  _exports.default = SocialProfilesController;
});